import { render, staticRenderFns } from "./OrderHistory.vue?vue&type=template&id=7b686c70"
import script from "./OrderHistory.vue?vue&type=script&lang=js"
export * from "./OrderHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b686c70')) {
      api.createRecord('7b686c70', component.options)
    } else {
      api.reload('7b686c70', component.options)
    }
    module.hot.accept("./OrderHistory.vue?vue&type=template&id=7b686c70", function () {
      api.rerender('7b686c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/OrderHistory.vue"
export default component.exports